module.exports = __webpack_public_path__ + "img/pr-3.cd4e6009.png";